import { render, staticRenderFns } from "./Location.vue?vue&type=template&id=20edb9a4"
import script from "./Location.vue?vue&type=script&lang=js"
export * from "./Location.vue?vue&type=script&lang=js"
import style0 from "./Location.vue?vue&type=style&index=0&id=20edb9a4&prod&lang=scss"
import style1 from "./Location.vue?vue&type=style&index=1&id=20edb9a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports